import React from 'react';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';

import type { AttachmentsStore } from 'widget/stores/AttachmentsStore';
import useHorizontalScroll from 'widget/hooks/useHorizontalScroll';

import { AttachmentItem } from './AttachmentItem';
import styles from './AttachmentsList.module.scss';

export type AttachmentsListProps = {
  attachmentsStore: AttachmentsStore;
  className?: string;
};

const AttachmentsList: React.FC<AttachmentsListProps> = ({
  attachmentsStore,
  className
}) => {
  const { attachments } = attachmentsStore;
  const listRef = React.useRef<HTMLDivElement>(null);

  useHorizontalScroll(listRef, attachments.length);

  if (attachments.length === 0) {
    return null;
  }

  return (
    <div className={cn(styles['attachments-wrapper'], className)}>
      <div
        className={cn(
          styles['attachments-shadow'],
          styles['attachments-shadow_left']
        )}
      />
      <div ref={listRef} className={styles['attachments-list']}>
        {attachments.map((attachment) => (
          <AttachmentItem
            key={attachment.id}
            attachment={attachment}
            onRemove={attachmentsStore.removeAttachment}
            onRetry={attachmentsStore.retryUpload}
          />
        ))}
      </div>
      <div
        className={cn(
          styles['attachments-shadow'],
          styles['attachments-shadow_right']
        )}
      />
    </div>
  );
};

export default observer(AttachmentsList);
